import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { Hero } from '../components/vsl/Hero';
import { PainSection } from '../components/vsl/PainSection';
import { MethodSection } from '../components/vsl/MethodSection';
import { ModulesSection } from '../components/vsl/ModulesSection';
import { BonusSection } from '../components/vsl/BonusSection';
import { OfferSection } from '../components/vsl/OfferSection';
import { FaqSection } from '../components/vsl/FaqSection';
import { StickyCta } from '../components/vsl/StickyCta';
import { SiteFooter } from '../components/vsl/SiteFooter';
import { PixelDebugPanel } from '../components/vsl/PixelDebugPanel';
type CurlySeduccionProps = {
  showStickyCta: boolean;
  debugPixel: boolean;
};
export function CurlySeduccion({
  showStickyCta,
  debugPixel
}: CurlySeduccionProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ink font-sans" data-id="element-143" data-mp="1h00fwnd619hu">
      <Hero data-id="element-144" data-mp="1gz7gy8kg7oa9" />
      <main data-id="element-145" data-mp="1gyfm4zyodul1">
        <PainSection data-id="element-146" data-mp="gg12ev4k2gn6" />
        <MethodSection data-id="element-147" data-mp="gfhkvfithu9o" />
        <ModulesSection data-id="element-148" data-mp="ghc5stu39mdr" />
        <BonusSection data-id="element-149" data-mp="ggswg1ii86bc" />
        <OfferSection data-id="element-150" data-mp="lf488hsd0qw7" />
        <FaqSection data-id="element-151" data-mp="lfm0l3bwikyu" />
      </main>
      <SiteFooter data-id="element-152" data-mp="lekqp26mg4ip" />
      {showStickyCta && <StickyCta data-id="element-153" data-mp="6q7rlwc8m5jz" />}
      {debugPixel && <PixelDebugPanel data-id="element-154" data-mp="6qzmt61xa19q" />}
    </div>;
}